import { Theme } from "@mui/material";

import createStyles from '@mui/styles/createStyles';

export const styles = (theme: Theme) =>
	createStyles({
		toolbar: {
			marginBottom: theme.spacing(2)
		},
		formControl: {
			marginTop: theme.spacing(1),
			marginRight: theme.spacing(2)
		},
		selectMenu: {
			paddingTop: 2,
			paddingBottom: 2,
			paddingRight: 27
		},
		selectOption: {
			minHeight: 25
		}
	});
